import styles from "./index.module.scss";
import { CmsImage, DatoColor } from "../types";

interface Props {
  color?: DatoColor;
  mcolor?: DatoColor;
  className?: string;
}

export function Underline({ color, mcolor, className = "" }: Props): JSX.Element {
  const lineColor = mcolor ?? color;
  const style = {
    "--line": lineColor?.hex,
  } as React.CSSProperties;
  return (
    <span
      style={style as React.CSSProperties}
      className={`${styles.underline} underline w-full brandUnderline block ${className}`.trim()}
    />
  );
}

interface CustomProps {
  color?: DatoColor;
  mcolor?: DatoColor;
  shape: CmsImage;
  className?: string;
}

export function CustomUnderline({
  color,
  mcolor,
  shape,
  className = "",
}: CustomProps): JSX.Element {
  const lineColor = mcolor ?? color;
  const style = {
    "--line": lineColor?.hex,
    "--shape": `url(${shape?.url})`,
  } as React.CSSProperties;
  return (
    <span
      style={style as React.CSSProperties}
      className={`${styles.underlineCustom} w-full brandUnderline block ${className}`.trim()}
    />
  );
}

export function CustomUnderlineBolder({
  color,
  shape,
}: CustomProps): JSX.Element {
  const style = {
    "--line": color?.hex,
    "--shape": `url(${shape?.url})`,
  } as React.CSSProperties;
  return (
    <span
      style={style as React.CSSProperties}
      className={`${styles.underlineCustom}   md:w-[100%]  min-w-[3rem] lg:min-w-[7rem] translate-y-[-1rem] lg:translate-x-4 z-[0] relative  h-[2rem]  max-w-[25rem]  
       `}
    ></span>
  );
}
